import { render, staticRenderFns } from "./addCtp.vue?vue&type=template&id=45fbb6fb&scoped=true&"
import script from "./addCtp.vue?vue&type=script&lang=js&"
export * from "./addCtp.vue?vue&type=script&lang=js&"
import style0 from "./addCtp.vue?vue&type=style&index=0&id=45fbb6fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbb6fb",
  null
  
)

export default component.exports